import { Fragment } from 'react'
import { MenuItem, MenuItems, Transition } from '@headlessui/react'
import { CheckIcon, ImageCircle, cn } from '$components'
import { User } from '$api-client/types.gen'

export type PersonSelectDesktopContentProps = {
  options: User[]
  selectedPeopleIds: number[]
  onSelectPerson: (person: User) => void
  onClear: () => void
}

export function PersonSelectDesktopContent({
  options,
  selectedPeopleIds,
  onSelectPerson,
  onClear,
}: PersonSelectDesktopContentProps) {
  return (
    <Transition
      as={Fragment}
      enter="transition ease-enter duration-micro"
      enterFrom="transform opacity-0 scale-95"
      enterTo="transform opacity-100 scale-100"
      leave="transition ease-exit duration-micro"
      leaveFrom="transform opacity-100 scale-100"
      leaveTo="transform opacity-0 scale-95"
    >
      <MenuItems
        anchor="bottom start"
        className="z-70 shadow-popover rounded-surface"
      >
        <div className="flex flex-col bg-surface border border-border rounded-surface text-body-sm w-44 mt-stack-dense h-full max-h-48 overflow-y-auto">
          <MenuItem>
            <button
              type="button"
              onClick={onClear}
              className="w-full text-left py-stack-tight px-stack text-fg-muted hover:bg-bg-subtle/50 [&:not(:last-child)]:border-b border-border"
            >
              All
            </button>
          </MenuItem>

          {options.map((person, key) => (
            <MenuItem key={key}>
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  onSelectPerson(person)
                }}
                className={cn(
                  'flex text-left py-stack-tight px-stack hover:bg-bg-subtle/50 text-fg-muted items-center gap-stack-tight',
                  'relative',
                )}
              >
                <span className="absolute top-1/2 -translate-y-1/2 right-2">
                  {selectedPeopleIds.includes(person.id) && (
                    <CheckIcon className="size-4 text-brand-hover" />
                  )}
                </span>

                <ImageCircle
                  size="sm"
                  image={person.image}
                />

                <span className="truncate mr-stack-roomy">
                  {person.first_name + ' ' + person.last_name}
                </span>
              </button>
            </MenuItem>
          ))}
        </div>
      </MenuItems>
    </Transition>
  )
}
